export default __webpack_public_path__ + "static/media/gallery-wip-connection-rods_04.aebf48c4.jpg";